<template>
  <div class="card steps-historique"
       id="historique">
    <header class="header-card">
      <p v-if="sens === sensVente">{{ $t('detail.commande.historique.title') }}</p>
      <p v-else>{{ $t('detail.commande.historique.achat.title') }}</p>
    </header>
    <div class="card-content steps-container">
      <ul class="steps is-vertical has-content-centered" v-if="historique.length > 0">
        <li v-for="(commande, index) in historique" :key="index"
            class="steps-segment"
            :class="{'is-active': isActive(commande)}">
          <div class="steps-marker"></div>
          <div class="steps-content">
            <span class="has-text-link is-size-5 has-text-weight-bold">
              {{ getTitle(index) }}
            </span>
            <span class="has-text-default is-size-7" v-if="sens === sensVente">
            - {{ commande.dateDevisCommande | formatDate }}
            </span>
            <span class="has-text-default is-size-7" v-else-if="isReconduction(commande)">
              {{  $t('detail.commande.historique.achat.reconduction.for') }}
              {{ commande.dateReconduction | formatDate }}
            </span>
            <span v-else class="has-text-default is-size-7">
              {{ commande.dateDebutSignature | formatDate}}
              - {{ commande.dateFinSignature | formatDate }}
            </span>
            <div class="columns">
              <template v-if="!isReconduction(commande)">
                <router-link-blank v-if="index !== historique.length - 1"
                  class="column is-narrow is-paddingless mgt-10px pdl-10px pdr-5px"
                  :to="{ name: sens === sensVente ? 'c.bodac.commandes'
                  : 'c.baux.contrat', params: {id: commande.id }}"
                  :message="sens !== sensVente ? $t('detail.commande.historique.achat.commandeMaj',
                  { code: commande.code }) : $t('detail.commande.historique.commandeMaj',
                  { code: commande.code })"/>
                <span class="has-text-default column is-narrow is-paddingless
                mgt-10px" :class="{'pdl-10px': index === historique.length - 1 }">
                  {{ getDescription(index) }}
                </span>
              </template>
              <template v-else>
                <span class="column is-narrow is-paddingless mgt-10px pdl-10px pdr-5px">
                  {{ getReconductionDescription(index) }}
                </span>
              </template>
              <router-link-blank
                class="column is-narrow is-paddingless mgt-10px pdl-5px"
                :to="getPathCommande(commande)"
                :message="getCodeCommande(index)"/>
              <div class="column">({{ $t(getEtatLibelle(commande.etat)) }})</div>
            </div>
              <detail-historique v-if="sens === sensVente"
                :commandeId="commande.id"/>
          </div>
        </li>
      </ul>
      <div v-else class="has-text-weight-bold has-text-link">
        <p v-if="sens === sensVente">{{ $t('detail.commande.historique.pasHistorique') }}</p>
        <p v-else>{{ $t('detail.commande.historique.achat.pasHistorique') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as devisConf from '@/configuration/devisConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import detailHistorique from './detailHistorique';

export default {
  name: 'GeneralHistorique',
  props: {
    historique: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    sens: {
      type: String,
      required: false,
      default: devisConf.SENS_VENTE,
    },
    etats: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sensVente: devisConf.SENS_VENTE,
      detailsCommandes: [],
    };
  },
  components: {
    routerLinkBlank,
    detailHistorique,
  },
  computed: {
    lastReconduction() {
      const reconduction = this.historique.filter((historique) => {
        return !!historique.dateReconduction && historique.id === this.id;
      })?.[0];
      return reconduction;
    },
  },
  methods: {
    getTitle(index) {
      if (this.isReconduction(this.historique[index])) {
        return this.$t('detail.commande.historique.achat.reconduction.title');
      }
      if (this.sens === devisConf.SENS_VENTE) {
        if (index === this.historique.length - 1) return this.$t('detail.commande.historique.creation');
        if (this.historique[index + 1].etatRenouvellement === devisConf.ETAT_RENOUVELEE) return this.$t('detail.commande.historique.renouvellement');
        return this.$t('detail.commande.historique.tacite');
      }
      if (index === this.historique.length - 1) return this.$t('detail.commande.historique.achat.creation');
      return this.$t('detail.commande.historique.achat.renouvellement');
    },
    getReconductionDescription(index) {
      return this.historique[index].commentaireReconduction;
    },
    getDescription(index) {
      if (this.sens === devisConf.SENS_VENTE) {
        if (index === this.historique.length - 1) return this.$t('detail.commande.historique.creationDescription');
        if (this.historique[index + 1].etatRenouvellement === devisConf.ETAT_RENOUVELEE) return this.$t('detail.commande.historique.renouvellementDescription');
        return this.$t('detail.commande.historique.taciteDescription');
      }
      if (index === this.historique.length - 1) return this.$t('detail.commande.historique.achat.creationDescription');
      return this.$t('detail.commande.historique.achat.renouvellementDescription');
    },
    getCodeCommande(index) {
      if (this.sens === devisConf.SENS_VENTE) {
        if (index === this.historique.length - 1) return this.$t('detail.commande.historique.commande', { code: this.historique[index].code });
        return this.$t('detail.commande.historique.commande', { code: this.historique[index + 1].code });
      }
      if (index === this.historique.length - 1) return this.$t('detail.commande.historique.achat.commande', { code: this.historique[index].code });
      return this.$t('detail.commande.historique.achat.commande', { code: this.historique[index + 1].code });
    },
    getIdCommande(index) {
      if (index === this.historique.length - 1) return this.historique[index].id;
      return this.historique[index + 1].id;
    },
    getEtatLibelle(etat) {
      const etatFind = this.etats.find((listeEtat) => {
        return listeEtat.code === etat;
      });
      return etatFind?.libelle || '';
    },
    isReconduction(historique) {
      return !!historique.dateReconduction;
    },
    isActive(commande) {
      if (this.lastReconduction) {
        return commande.dateReconduction === this.lastReconduction.dateReconduction;
      }
      return this.id === commande.id;
    },
    getPathCommande(commande) {
      if (this.sens === devisConf.SENS_VENTE) {
        return {
          name: 'c.bodac.commandes',
          params: { id: commande.id },
        };
      }
      return {
        name: 'c.baux.contrat',
        params: { id: commande.id },
      };
    },
  },
};
</script>

<style scoped>

</style>
